import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Button, Row, Col } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import RouterPaths from '../constants/RouterPaths';
import AdminsTable from './AdminsTable';
import AdminsSearch from './search/AdminsSearch';
import AdminsStatusFilter from './AdminsStatusFilter';
import PageBreadcrumb from '../common/components/layout/PageBreadcrumb';
import { searchAdmin } from './AdminsActions';
import { setQueryString, useQueryString } from '../common/helpers/queryString';

function AdminsPage() {
  const query = useQueryString();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const initialSearchParams = {
    offset: query.get('page') ? +query.get('page') - 1 : 0,
  };

  const previousSearchState = useSelector((state) => state.admins.get('searchState'));
  const items = useSelector((state) => state.admins.get('items'));
  const totalItems = useSelector((state) => state.admins.get('totalItems'));

  const [searchParams, setSearchParams] = useState(
    previousSearchState?.searchParams || initialSearchParams,
  );

  useEffect(() => {
    dispatch(searchAdmin(searchParams));
  }, [dispatch, searchParams]);

  const handleChangeStatus = (status) => {
    setSearchParams((prevState) => ({ ...prevState, status, offset: 0 }));
  };

  const handleSearch = (values, { setSubmitting }) => {
    setSearchParams((prevState) => ({ ...prevState, ...values, offset: 0 }));
    setSubmitting(false);
  };

  const changeOffset = (value) => {
    setSearchParams((prevState) => ({ ...prevState, offset: value }));
    navigate(setQueryString(location, 'page', value + 1));
  };

  const breadcrumbs = [
    { id: 1, type: 'home' },
    { id: 2, type: 'span', text: 'Admins' },
  ];

  return (
    <Container fluid>
      <PageBreadcrumb items={breadcrumbs} pageTitle="Admins" />
      <Row className="mb-3">
        <Col xs="12">
          <Button
            className="rounded-pill btn-primary float-end"
            onClick={() => navigate(RouterPaths.CREATE_ADMIN)}
          >
            Add Admin
          </Button>
        </Col>
      </Row>
      <Row>
        <AdminsSearch onSearch={handleSearch} />
      </Row>
      <Row>
        <AdminsStatusFilter
          onChangeStatus={handleChangeStatus}
          previousSelectedStatus={previousSearchState?.searchParams?.status}
        />
      </Row>
      <Row>
        <AdminsTable
          data={{ items, total: totalItems }}
          offset={searchParams.offset}
          changeOffset={changeOffset}
          searchParams={searchParams}
        />
      </Row>
    </Container>
  );
}

export default AdminsPage;
